import actionTypes from 'constants/actionTypes'

interface PromptAction {
  type: string
  payload?: {
    prompt?: string
  }
}


export default (state = '', action: PromptAction): string => {
  if (action.type === actionTypes.PROMPT.CHANGED) {
    return action.payload?.prompt ?? state
  }
  return state
}
